import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["xsm", "sm", "md", "lg", "xlg", "xxlg", "wd", "xwd", "at", "from", "until", "component", "tagName", "className", "children"];
import _Object$values from "@babel/runtime-corejs2/core-js/object/values";
import * as React from 'react';
import pick from 'lodash/pick';
import clsx from 'clsx';
var styles = {
  "all": "SrOnly-all_3sYcg",
  "xsm": "SrOnly-xsm_1RcJL",
  "sm": "SrOnly-sm__Q7ui",
  "md": "SrOnly-md_2a_gt",
  "lg": "SrOnly-lg_3q4wX",
  "xlg": "SrOnly-xlg_Zt44Z",
  "xxlg": "SrOnly-xxlg_8W6qs",
  "wd": "SrOnly-wd_2uIj1",
  "xwd": "SrOnly-xwd_YII05",
  "from-xsm": "SrOnly-from-xsm_3bl_o",
  "from-sm": "SrOnly-from-sm_1eEk3",
  "from-md": "SrOnly-from-md_2VT0D",
  "from-lg": "SrOnly-from-lg_jCyy2",
  "from-xlg": "SrOnly-from-xlg_4J2Va",
  "from-xxlg": "SrOnly-from-xxlg_381sd",
  "from-wd": "SrOnly-from-wd_1CqJO",
  "from-xwd": "SrOnly-from-xwd_AZ8rl",
  "until-xsm": "SrOnly-until-xsm_3l88J",
  "until-sm": "SrOnly-until-sm_2PC-9",
  "until-md": "SrOnly-until-md_3sxG5",
  "until-lg": "SrOnly-until-lg_1vU7F",
  "until-xlg": "SrOnly-until-xlg_2Ze-2",
  "until-xxlg": "SrOnly-until-xxlg_w4-8H",
  "until-wd": "SrOnly-until-wd_M_33q",
  "until-xwd": "SrOnly-until-xwd_3YaZa"
};
function SrOnly(props) {
  var _clsx;
  var xsm = props.xsm,
    sm = props.sm,
    md = props.md,
    lg = props.lg,
    xlg = props.xlg,
    xxlg = props.xxlg,
    wd = props.wd,
    xwd = props.xwd,
    at = props.at,
    from = props.from,
    until = props.until,
    component = props.component,
    _props$tagName = props.tagName,
    tagName = _props$tagName === void 0 ? 'span' : _props$tagName,
    className = props.className,
    children = props.children,
    extraProps = _objectWithoutProperties(props, _excluded);
  var hasBreapoint = _Object$values(pick(props, ['xsm', 'sm', 'md', 'lg', 'xlg', 'xxlg', 'wd', 'xwd', 'at', 'from', 'until'])).some(Boolean);
  var rootClasses = clsx((_clsx = {}, _defineProperty(_clsx, styles.all, !hasBreapoint), _defineProperty(_clsx, styles.xsm, xsm), _defineProperty(_clsx, styles.sm, sm), _defineProperty(_clsx, styles.md, md), _defineProperty(_clsx, styles.lg, lg), _defineProperty(_clsx, styles.xlg, xlg), _defineProperty(_clsx, styles.xxlg, xxlg), _defineProperty(_clsx, styles.wd, wd), _defineProperty(_clsx, styles.xwd, xwd), _clsx), at && styles[at], from && styles["from-".concat(from)], until && styles["until-".concat(until)], className);
  if (component && /*#__PURE__*/React.isValidElement(component)) {
    // $FlowFixMe[cannot-spread-inexact]
    return /*#__PURE__*/React.cloneElement(component, _objectSpread({
      className: clsx(component.props.className, rootClasses)
    }, extraProps));
  }
  if (typeof children === 'string') {
    return /*#__PURE__*/React.createElement(tagName, // $FlowFixMe[cannot-spread-inexact]
    _objectSpread({
      className: rootClasses
    }, extraProps), children);
  }

  // Ensure null children filtering by converting to a true Array.
  return React.Children.toArray(children).map(function (child) {
    return /*#__PURE__*/React.isValidElement(child) ?
    /*#__PURE__*/
    // $FlowFixMe[incompatible-type]
    // $FlowFixMe[incompatible-exact]
    React.cloneElement(child, {
      // $FlowFixMe[prop-missing]
      // $FlowFixMe[incompatible-use]
      className: clsx(child.props.className, rootClasses)
    }) : child;
  });
}
export default SrOnly;